import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { PhonePanelProvider } from '../../../providers/phone-panel/phone-panel';
import { HistoryProvider } from '../../../providers/history/history';
import {Events} from '../../../providers/events';
import {AddressData} from '../../../interfaces/address-data';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the PhoneCallPanelComponent component.
 */
@Component({
  selector: 'phone-call-panel',
  templateUrl: 'phone-call-panel.html',
  styleUrls: ['./phone-call-panel.scss']
})
export class PhoneCallPanelComponent {

  adressData: AddressData = new AddressData();

  @Input() set address(data: AddressData) {
    this.adressData = data;
  }

  @Input() showHeader = true;

  @Input()
  callNumber: any;
  commentRequired = true;
  callResult = true;
  callForm: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder, 
    public phonePanelProvider: PhonePanelProvider, 
    private historyProvider: HistoryProvider, private alertCtrl: AlertController, 
    private translate:TranslateService,
    private events: Events) {
    this.callForm = this.formBuilder.group({
      comment: [''],
      callResult: ['']
    }, {validator: () => {
      
      if (this.callForm) {
        if (!(this.callForm.get('callResult').value) && !(this.callForm.get('comment').value)) {
         if(!(this.callForm.get('callResult').value)){
          this.callForm.controls.callResult.setErrors({ 'incorrect': true});
         }
         if(!(this.callForm.get('comment').value)){
          this.callForm.controls.callResult.setErrors({ 'comment': true});
         }
        } else {
          this.callForm.controls.callResult.setErrors(null);
          this.callForm.controls.comment.setErrors(null);
        }  
      }
    }});

    this.events.subscribe('changeTabData', () => {
      this.phonePanelProvider.addressData = new AddressData();
      this.phonePanelProvider.phoneData.phoneNumber = '';
    });
  }

  changeCallResult() {
    this.callForm.controls.comment.setValidators([]);
    this.callForm.controls.comment.updateValueAndValidity();
  }

  async initiateCall() {
    if (this.callForm.valid) {
      this.historyProvider.setHistoryData({
        dateTime: new Date().getTime(),
        code : '7777',
        desc : this.callForm.get('comment').value + ' ' + this.callForm.get('callResult').value,
        editorPerson : this.phonePanelProvider.api._user.profile.firstname + ' ' + this.phonePanelProvider.api._user.profile.lastname
      });

      await this.phonePanelProvider.callNumber(this.phonePanelProvider.phoneData.phoneNumber, this.phonePanelProvider.api._user.profile.callNumber);

      this.historyProvider.setHistoryData({
        dateTime: new Date().getTime(),
        code : '7778',
        desc : this.translate.instant('CallStart')+':\n'+this.phonePanelProvider.api._user.profile.callNumber,
        editorPerson : this.phonePanelProvider.api._user.profile.firstname + ' ' + this.phonePanelProvider.api._user.profile.lastname
      });
    
    } else {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('Warning'),
        message: this.translate.instant('Message.CallFormInfo'),
        cssClass: 'alert-warning',
        buttons: [this.translate.instant('Close')]
      });
      alert.present();
    }
  }

}
